import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconButton: {
      width: 50,
      height: 50,
    },
    periodLabel: {
      fontSize: 16,
      fontWeight: 'bold',
      margin: '10px 0px',
      color: theme.palette.primary.main,
    },
    buttons: {
      justifyContent: 'space-between',
      padding: 20,
    },
    itemText: {
      textTransform: 'uppercase',
    },
    root: {
      minWidth: 300,
    },
  }),
);

export default useStyles;
